import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Header from './header/header';
import About from './about/about';
import Projects from './projects/projects';
import Now from './now/now';
import Contact from './contact/contact';
import './index.css';

ReactDOM.render(
  <Header />,
  document.getElementById('header')
);

ReactDOM.render(
  <App />,
  document.getElementById('intro')
);

ReactDOM.render(
  <About />,
  document.getElementById('about')
);

ReactDOM.render(
  <Projects />,
  document.getElementById('projects')
);

ReactDOM.render(
  <Now />,
  document.getElementById('now')
);

ReactDOM.render(
  <Contact />,
  document.getElementById('contact')
);


console.log("Hi. Not much to see here, I used simple React components together with small router and hosted on github pages. For the style, I really liked evanwknight.com site in terms of components positioning so I decided to use similar style. I prefer my fonts and colors though :)")


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/